import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import SafePureComponent from '../shared/SafePureComponent';
import buildTagUrl from '../../utils/tag';

import './style.scss';

class Tags extends Component {

    validateProps() {
        const { tags } = this.props;

        if (!tags) {
            return false;
        }

        const { tagsGigList } = tags;
        return !_.isEmpty(tagsGigList);
    }

    createFormattedTagsList() {
        const { pathfinderWrapper } = this.context;
        const { tagsGigList } = this.props.tags;

        return tagsGigList.map(({ name, formattedClassification }) => ({
            text: name,
            url: buildTagUrl(pathfinderWrapper, formattedClassification)
        }));
    }

    render() {

        if (!this.validateProps()) {
            return null;
        }

        const tagsList = this.createFormattedTagsList();

        return (
            <div className="gig-tags-container">
                <h2 className="section-title"><I18n k={'gig_page_perseus.tags.title'}/></h2>
                <ul>
                    {tagsList.map((tag) => (
                        <li key={tag.text}>
                            <a href={tag.url}>{tag.text}</a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

Tags.propTypes = {
    tags: PropTypes.shape({
        tagsGigList: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                formattedClassification: PropTypes.shape({
                    type: PropTypes.string,
                    key: PropTypes.oneOfType([
                        PropTypes.string,
                        PropTypes.Object
                    ])
                })
            })
        )
    }).isRequired
};

Tags.contextTypes = {
    pathfinderWrapper: PropTypes.object
};

export { Tags };
export default SafePureComponent(Tags);
